import { Attr, BelongsTo, Model } from "spraypaint";

import InstagramHandle from "shared/resources/InstagramHandle";
import OrganisationSocialIntegration from "shared/resources/OrganisationSocialIntegration";
import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class InstagramHandlesOrganisationSocialIntegration extends ApplicationRecord {
  static jsonapiType = "instagram_handles_organisation_social_integrations";

  @BelongsTo() instagramHandle: InstagramHandle;

  @BelongsTo() organisationSocialIntegration: OrganisationSocialIntegration;

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default InstagramHandlesOrganisationSocialIntegration;
